{
  "COOKIE_CONSENT": {
    "MESSAGE": "This site uses cookies to improve your browsing experience. By clicking \"Accept\", you agree to the use of cookies. ",
    "PRIVACY_LINK": "Click here for our Privacy Policy",
    "ACCEPT": "Accept"
  },
  "TOP_CATALOG": {
    "UNAVAILABLE_TITLE": "Manufacturer catalog is currently unavailable",
    "UNAVAILABLE_DESC": "The service is not active in this environment or the subscription has expired. Please contact support."
  },
  "COMMON": {
    "LOADING": "Loading...",
    "ERROR": "Error",
    "SAVE": "Save",
    "CANCEL": "Cancel",
    "CONFIRM": "Confirm",
    "DELETE": "Delete",
    "EDIT": "Edit",
    "CLOSE": "Close",
    "SEARCH": "Search",
    "FIND_PART": "Find Part",
    "ADD_TO_CART": "Add to Cart",
    "IN_STOCK": "In Stock",
    "OUT_OF_STOCK": "Out of Stock",
    "LIMITED_STOCK": "Limited Stock",
    "VAT_INCLUDED": "incl. VAT",
    "NET_PRICE": "Net Price",
    "BRUTTO_PRICE": "Gross (excl. VAT)",
    "RECOMMENDED_PRICE": "Recommended Retail Price"
  },
  "NAV": {
    "CATALOG": "Catalog",
    "ABOUT": "About",
    "NEWS": "News",
    "SIGN_IN": "Sign In",
    "PROFILE": "Profile",
    "LOGOUT": "Logout",
    "HOME": "Home",
    "TOP_CATALOG": "Top Catalog",
    "TERMS": "Terms of Use",
    "PRIVACY": "Privacy Policy"
  },
  "SEARCH": {
    "PLATE_NUMBER": "License Plate Number",
    "SELECT_MANUFACTURER": "Select Manufacturer",
    "SELECT_MODEL": "Select Model",
    "ARTICLE_NUMBER": "Article Number",
    "CATALOG_TYPE_TITLE": "Select Catalog Type",
    "OUR_CATALOG": "Our Catalog",
    "TOP_CATALOG": "Top Catalog",
    "SELECT_SUBMODEL": "Select Submodel",
    "PLATE_NO_RESULTS": "No vehicle found for plate number",
    "ARTICLE_NO_RESULTS": "No results found for this article number",
    "PLATE_RESULTS": "Select your vehicle",
    "LIMITED_STOCK": "Limited stock",
    "OR": "or",
    "SEARCH_BY_MODEL": "Search by make & model",
    "HIDE_MODEL_SEARCH": "Hide model search"
  },
  "AUTH": {
    "LOGIN": "Login",
    "REGISTER": "Register",
    "EMAIL": "Email",
    "EMAIL_PLACEHOLDER": "your@email.com",
    "PASSWORD": "Password",
    "PASSWORD_PLACEHOLDER": "At least 7 characters",
    "FORGOT_PASSWORD": "Forgot Password",
    "RESET_PASSWORD": "Reset Password",
    "FULL_NAME": "Full Name",
    "PHONE": "Phone",
    "COMPANY_NAME": "Company Name",
    "DEALER_NUMBER": "Dealer Number",
    "ADDRESS": "Address",
    "LOGIN_TITLE": "Sign in to your account",
    "LOGIN_BTN": "Sign In",
    "FORGOT_TITLE": "Forgot Password",
    "FORGOT_DESC": "Enter your email address and we'll send you a reset link",
    "FORGOT_SEND": "Send Reset Link",
    "FORGOT_SUCCESS": "Reset link sent to",
    "BACK_TO_LOGIN": "Back to login",
    "RESET_TITLE": "Set New Password",
    "NEW_PASSWORD": "New Password",
    "CONFIRM_PASSWORD": "Confirm Password",
    "RESET_BTN": "Save Password",
    "RESET_LINK_INVALID": "The link is invalid or has expired",
    "REQUEST_NEW_LINK": "Request a new link",
    "RESET_SUCCESS": "Password changed successfully!",
    "CONFIRMING_EMAIL": "Confirming email address...",
    "EMAIL_CONFIRMED": "Email confirmed successfully!",
    "EMAIL_CONFIRM_ERROR": "Email confirmation failed. The link is invalid.",
    "VALIDATING": "Validating link..."
  },
  "PROFILE": {
    "TITLE": "My Account",
    "EDIT_TITLE": "Edit Profile",
    "PASSWORD_TITLE": "Change Password",
    "HISTORY_TITLE": "Order History",
    "LOGOUT": "Logout",
    "FULL_NAME": "Full Name",
    "PHONE": "Phone",
    "ADDRESS": "Address",
    "SAVE": "Save Changes",
    "OLD_PASSWORD": "Current Password",
    "NEW_PASSWORD": "New Password",
    "CONFIRM_NEW_PASSWORD": "Confirm New Password",
    "NO_ORDERS": "No orders yet",
    "ORDER_ID": "Order #",
    "ORDER_DATE": "Date",
    "ORDER_STATUS": "Status",
    "ORDER_TOTAL": "Total",
    "VIEW_ORDER": "View",
    "NET_TOTAL": "Net Total",
    "GROSS_TOTAL": "Gross Total",
    "COMMENTS": "Comments",
    "QUANTITY": "Qty",
    "REORDER": "Reorder"
  },
  "HOME": {
    "HERO_TITLE": "Find Auto Parts Fast",
    "HERO_SUBTITLE": "Search by license plate, manufacturer or article number",
    "CATEGORIES_TITLE": "Parts Catalog",
    "CATEGORIES_SUBTITLE": "Explore our comprehensive inventory by system category.",
    "CATEGORIES_VIEW_ALL": "View Full Category Index",
    "CATEGORIES_SEARCH": "Search for a category or part...",
    "BRANDS_TITLE": "Top Brands",
    "BEST_SELLERS_TITLE": "Best Sellers",
    "POPULAR_TITLE": "Popular Parts",
    "POPULAR_SKU_LABEL": "SKU",
    "NEWS_TITLE": "News",
    "VIEW_ALL": "View All",
    "BEST_SELLER": "Best Seller",
    "HERO_FEATURE_IMPORT": "Global Import Network",
    "HERO_FEATURE_QUALITY": "High-Quality Inventory",
    "HERO_FEATURE_DELIVERY": "Fast Delivery Across Israel",
    "ADVANTAGES_IMPORT_DESC": "Supply sources from leading countries worldwide",
    "ADVANTAGES_QUALITY_DESC": "Huge variety of parts for all vehicle types",
    "ADVANTAGES_DELIVERY_DESC": "High availability and fast shipping nationwide",
    "CAT_BRAKES": "Brake System",
    "CAT_FILTERS": "Filters",
    "CAT_CHASSIS": "Chassis & Steering",
    "CAT_ENGINE": "Engine Parts",
    "CAT_ELECTRICAL": "Electrical & A/C",
    "CAT_LIGHTING": "Lighting & Body"
  },
  "NAV_EXTRA": {
    "HOME": "Home"
  },
  "CATALOG": {
    "FILTERS": "Filters",
    "CLEAR_ALL": "Clear all",
    "APPLY": "Apply",
    "PRICE_RANGE": "Price Range",
    "BRAND": "Brand",
    "IN_STOCK": "In Stock Only",
    "NO_RESULTS": "No results found",
    "NO_RESULTS_HINT": "Try changing the filters or search for something else",
    "POSITION": "Position",
    "NO_CATEGORIES": "No categories found",
    "CATEGORIES": "Categories",
    "SEARCH_CATEGORIES": "Search category...",
    "TOP_CATALOG": "Manufacturer Catalog",
    "TOP_CATEGORIES": "Popular Categories",
    "SUBCATEGORIES": "subcategories",
    "NO_ARTICLES": "No articles found",
    "SHOWING": "Showing",
    "RESULTS": "results",
    "FOR": "for"
  },
  "PRODUCT": {
    "ARTICLE_NUMBER": "Part Number",
    "BRAND": "Brand",
    "IN_STOCK": "In Stock",
    "LIMITED_STOCK": "Limited Stock",
    "OUT_OF_STOCK": "Out of Stock",
    "CHARACTERISTICS": "Technical Specifications",
    "NO_CHARACTERISTICS": "No specifications available",
    "OEM_REFERENCES": "OEM References",
    "NO_OEMS": "No OEM references available",
    "COMPATIBLE_CARS": "Vehicle Compatibility",
    "NO_COMPATIBLE_CARS": "No compatibility data available",
    "NOT_FOUND": "Product not found"
  },
  "CONTACT": {
    "TITLE": "Need a specific part?",
    "SUBTITLE": "We're here to help!",
    "NAME": "Full Name",
    "PHONE": "Phone",
    "EMAIL": "Email",
    "MESSAGE": "Message",
    "SEND": "Send",
    "SENT": "Message sent! We'll get back to you soon.",
    "SERVICE": "Professional Service",
    "CONSULTING": "Expert Consulting",
    "PRICING": "Competitive Prices"
  },
  "ADMIN": {
    "SWITCH_CUSTOMER": "Switch Customer",
    "MY_ACCOUNT": "My Account",
    "SEARCH_CUSTOMER": "Search customer...",
    "ACTING_AS": "Acting as",
    "CUSTOMERS_TITLE": "Select Customer",
    "RETURN_TO_ADMIN": "Return to my account"
  },
  "CART": {
    "TITLE": "Shopping Cart",
    "EMPTY": "Your cart is empty",
    "SUBTOTAL": "Subtotal",
    "VAT": "VAT",
    "TOTAL": "Total",
    "ITEMS_COUNT": "Items",
    "DELIVERY_METHOD": "Delivery Method",
    "SELECT_DELIVERY": "Select delivery method",
    "DELIVERY_ADDRESS": "Delivery Address",
    "COMMENT": "Comment",
    "CONFIRM_ORDER": "Confirm Order",
    "ORDER_DETAILS": "Order Details",
    "PAYMENT_LINK_SENT": "A payment link has been sent to your email",
    "SUCCESS_TITLE": "Order Received!",
    "SUCCESS_DESC": "A representative will contact you shortly",
    "PROMO_PRICE": "Promotional price",
    "REGULAR_PRICE": "Regular price",
    "PROMO_HINT": "Add {{ moq }} or more units for promotional price ₪{{ price }}"
  }
}